import {
    IAlphaMiniCartModel,
    IProductItemViewModelTrackingData,
    IOrderItem,
} from 'Scripts/Types/Litium';
import store from 'Scripts/store';

type IDataLayerEvent = 'add' | 'remove';

export const handleCheckoutClickDatalayerPush = () => {
    const state = store.getState() as {
        cart: { miniCartModel: IAlphaMiniCartModel };
    };
    const { shoppingCart } = state.cart.miniCartModel;

    if (shoppingCart.orderItems.length > 0) {
        window.dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {
                        step: 1,
                    },
                    products: shoppingCart.orderItems.map(item => ({
                        name: item.dataLayerCarrierModel.baseIdAndName,
                        id: item.dataLayerCarrierModel.variantId,
                        id7: item.dataLayerCarrierModel.variantId7,
                        id5: item.dataLayerCarrierModel.variantId5,
                        price: item.dataLayerCarrierModel.price,
                        variant: item.dataLayerCarrierModel.color,
                        quantity: parseInt(item.dataLayerCarrierModel.quantity),
                        category: item.dataLayerCarrierModel.category,
                        dimension1: item.dataLayerCarrierModel.size,
                    })),
                },
                currencyCode:
                    shoppingCart.orderItems[0].dataLayerCarrierModel.currency,
            },
        });
    }
};

export const handleProductCardClickDatalayerPush = (
    trackingData: IProductItemViewModelTrackingData
) => {
    window.dataLayer.push({
        event: 'ee_product_click',
        ecommerce: {
            click: {
                actionField: {
                    list: 'Productcard',
                },
                products: [
                    {
                        name: trackingData.name,
                        id: trackingData.variantId,
                        price: trackingData.basePrice,
                        variant: trackingData.variant,
                    },
                ],
            },
        },
    });
};

export const handleChangeSizeVariantDatalayerPush = (
    trackingData: IProductItemViewModelTrackingData
) => {
    if (trackingData) {
        window.dataLayer.push({
            event: 'ee_products_details',
            ecommerce: {
                currencyCode: trackingData.currencyCode,
                detail: {
                    actiondField: {
                        list: trackingData.categoryName,
                    },
                    products: [
                        {
                            name: trackingData.name,
                            id: trackingData.variantId,
                            id7: trackingData.variantId7,
                            id5: trackingData.variantId5,
                            price: trackingData.basePrice,
                            category: trackingData.categoryName,
                            variant: trackingData.variant,
                            brand: trackingData.ecoLabel,
                        },
                    ],
                },
            },
        });
    }
};

export const handleAddToCartDatalayerPush = (
    trackingData: IProductItemViewModelTrackingData
) => {
    if (trackingData) {
        window.dataLayer.push({
            event: 'ee_add_to_cart',
            ecommerce: {
                currencyCode: trackingData.currencyCode,
                add: {
                    products: [
                        {
                            name: trackingData.name,
                            id: trackingData.variantId,
                            id7: trackingData.variantId7,
                            id5: trackingData.variantId5,
                            price: trackingData.basePrice,
                            category: trackingData.categoryName,
                            variant: trackingData.variant,
                            brand: trackingData.ecoLabel,
                        },
                    ],
                },
            },
        });
    }
};

export const handleOrderItemClickDatalayerPush = (item: IOrderItem) => {
    window.dataLayer.push({
        event: 'ee_product_click',
        ecommerce: {
            click: {
                actionField: {
                    list: 'Minicart',
                },
                products: [
                    {
                        name: item.dataLayerCarrierModel.baseIdAndName,
                        id: item.dataLayerCarrierModel.variantId,
                        price: item.dataLayerCarrierModel.price,
                        variant: item.dataLayerCarrierModel.color,
                    },
                ],
            },
        },
    });
};

export const handleItemDataLayerPush = (
    item: IOrderItem,
    event: IDataLayerEvent
) => {
    const products = [
        {
            name: item.dataLayerCarrierModel.baseIdAndName,
            id: item.dataLayerCarrierModel.variantId,
            price: item.dataLayerCarrierModel.price,
            variant: item.dataLayerCarrierModel.color,
            quantity: item.dataLayerCarrierModel.quantity,
            dimension1: item.dataLayerCarrierModel.size,
        },
    ];

    switch (event) {
        case 'remove':
            window.dataLayer.push({
                event: 'remove_from_cart',
                ecommerce: {
                    currencyCode: item.dataLayerCarrierModel.currency,
                    remove: {
                        products,
                    },
                },
            });
            break;

        case 'add':
            window.dataLayer.push({
                event: 'ee_add_to_cart',
                ecommerce: {
                    currencyCode: item.dataLayerCarrierModel.currency,
                    add: {
                        products,
                    },
                },
            });
            break;

        default: {
            const exhaustiveCheck: never = event;
            return exhaustiveCheck;
        }
    }
};

export const newsletterSignupDataLayerPush = (newsLetterEventType: string) => {
    window.dataLayer.push({
        event: 'userNewsletterRegister',
        trigger: newsLetterEventType,
    });
};

export const submitFormDataLayerPush = (eventType: string) => {
    window.dataLayer.push({
        event: eventType,
    });
};

export const logintUserDataLayerPush = () => {
    window.dataLayer.push({
        event: 'userLoggedInOnLoginPage',
    });
};

export const createAccountDataLayerPush = () => {
    window.dataLayer.push({
        event: 'create_account',
    });
};
